import { render, staticRenderFns } from "./WhereDashboard.vue?vue&type=template&id=b318354c&scoped=true&"
import script from "./WhereDashboard.vue?vue&type=script&lang=ts&"
export * from "./WhereDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./WhereDashboard.vue?vue&type=style&index=0&id=b318354c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b318354c",
  null
  
)

export default component.exports